// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/forester-film-edits-17.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IXFdfeY78Nt5TGWfqqYn {
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  padding: 2rem;
  clip-path: polygon(0% 0%, 25% 10%, 70% 0%, 100% 10%, 100% 100%, 50% 92%, 20% 100%, 0% 95%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-attachment: scroll;
  background-size: cover;
  background-position: center;
  margin-bottom: 4rem;
}

.fpfa1ckDocKp370wxIxi {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding: 2rem;
  border-radius: 1rem;
  margin: 0;
  white-space: normal;
}

.f3zTeKpPKUCMt8NV_zqp {
  overflow-y: scroll;
  max-height: 500px;
  width: 30%;
  padding: 0;
  white-space: normal;
  word-spacing: -0.2rem;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
  scrollbar-width: thin;
}
.f3zTeKpPKUCMt8NV_zqp ::-webkit-scrollbar {
  width: 8px;
}
.f3zTeKpPKUCMt8NV_zqp ::-webkit-scrollbar-track {
  background-color: transparent;
}
.f3zTeKpPKUCMt8NV_zqp ::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.EtmmejX8WTw1EIkva73k {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 0.3rem;
  transition: background-color 0.3s ease, color 0.3s ease;
  margin: 0;
  white-space: normal;
}
.EtmmejX8WTw1EIkva73k:hover {
  background-color: #f0f0f0;
}
.EtmmejX8WTw1EIkva73k:hover p {
  color: #333;
}
.EtmmejX8WTw1EIkva73k img {
  -o-object-fit: cover;
  object-fit: cover;
  width: 30%;
  margin: 0.3rem 1rem 0.3rem 1rem;
}
.EtmmejX8WTw1EIkva73k p {
  width: 70%;
  font-size: 0.9rem;
  color: #f1f1f1;
  transition: color 0.3s ease;
}

.VWPSXPUeoaj3Rv439YpH {
  flex-grow: 1;
}
.VWPSXPUeoaj3Rv439YpH iframe {
  width: 100%;
  height: 500px;
  border-radius: 6px;
  border: none;
}

@media screen and (max-width: 480px) {
  .IXFdfeY78Nt5TGWfqqYn {
    height: 60vh;
    margin-bottom: 3.5rem;
  }
  .fpfa1ckDocKp370wxIxi {
    flex-direction: column-reverse;
  }
  .f3zTeKpPKUCMt8NV_zqp {
    max-height: 200px;
    width: 100%;
  }
  .EtmmejX8WTw1EIkva73k img {
    width: 25%;
  }
  .EtmmejX8WTw1EIkva73k p {
    font-size: 0.75rem;
  }
  .VWPSXPUeoaj3Rv439YpH iframe {
    height: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/YoutubeSection/YoutubeSection.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,0FAAA;EACA,yDAAA;EACA,6BAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;EAeE,qDAAA;EACA,qBAAA;AAbJ;AADI;EACE,UAAA;AAGN;AAAI;EACE,6BAAA;AAEN;AACI;EACE,0CAAA;EACA,kBAAA;AACN;;AAMA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,uDAAA;EACA,SAAA;EACA,mBAAA;AAHF;AAKE;EACE,yBAAA;AAHJ;AAKI;EACE,WAAA;AAHN;AAOE;EACE,oBAAA;EACG,iBAAA;EACH,UAAA;EACA,+BAAA;AALJ;AAQE;EACE,UAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;AANJ;;AAUA;EACE,YAAA;AAPF;AAQE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AANJ;;AAUA;EAEE;IACE,YAAA;IACA,qBAAA;EARF;EAUA;IACE,8BAAA;EARF;EAWA;IACE,iBAAA;IACA,WAAA;EATF;EAaE;IACE,UAAA;EAXJ;EAcE;IACE,kBAAA;EAZJ;EAiBE;IACE,aAAA;EAfJ;AACF","sourcesContent":[".YoutubeSection {\n  width: 100%;\n  height: 80vh;\n  display: flex;\n  justify-content: center;\n  padding: 2rem;\n  clip-path: polygon(0% 0%, 25% 10%, 70% 0%, 100% 10%, 100% 100%, 50% 92%, 20% 100%, 0% 95%);\n  background-image: url('/public/img/forester-film-edits-17.jpg');\n  background-attachment: scroll;\n  background-size: cover;\n  background-position: center;\n  margin-bottom: 4rem;\n}\n\n.PlaylistContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  padding: 2rem;\n  border-radius: 1rem;\n  margin: 0;\n  white-space: normal;\n}\n\n.PlaylistSidebar {\n  overflow-y: scroll;\n  max-height: 500px;\n  width: 30%;  \n  padding: 0;\n  white-space: normal;\n  word-spacing: -.2rem;\n    \n    ::-webkit-scrollbar {\n      width: 8px; \n    }\n  \n    ::-webkit-scrollbar-track {\n      background-color: transparent; \n    }\n  \n    ::-webkit-scrollbar-thumb {\n      background-color: rgba(255, 255, 255, 0.3); \n      border-radius: 4px; \n    }\n  \n    scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\n    scrollbar-width: thin;\n}\n\n.PlaylistItem {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin-bottom: .3rem;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  margin: 0;\n  white-space: normal;\n\n  &:hover {\n    background-color: #f0f0f0;\n\n    p {\n      color: #333;\n    }\n  }\n\n  img {\n    -o-object-fit: cover;\n       object-fit: cover;\n    width: 30%;\n    margin: .3rem 1rem .3rem 1rem;\n  }\n\n  p {\n    width: 70%;\n    font-size: 0.9rem;\n    color: #f1f1f1;\n    transition: color 0.3s ease;\n  }\n}\n\n.PlaylistEmbed {\n  flex-grow: 1;\n  iframe {\n    width: 100%;\n    height: 500px;\n    border-radius: 6px;\n    border: none;\n  }\n}\n\n@media screen and (max-width: 480px) {\n\n  .YoutubeSection {\n    height: 60vh;\n    margin-bottom: 3.5rem;\n  }\n  .PlaylistContainer {\n    flex-direction: column-reverse;\n  }\n\n  .PlaylistSidebar {\n    max-height: 200px;\n    width: 100%;\n  }\n\n  .PlaylistItem {\n    img {\n      width: 25%;\n    }\n\n    p {\n      font-size: 0.75rem;\n    }\n  }\n\n  .PlaylistEmbed {\n    iframe {\n      height: 250px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"YoutubeSection": `IXFdfeY78Nt5TGWfqqYn`,
	"PlaylistContainer": `fpfa1ckDocKp370wxIxi`,
	"PlaylistSidebar": `f3zTeKpPKUCMt8NV_zqp`,
	"PlaylistItem": `EtmmejX8WTw1EIkva73k`,
	"PlaylistEmbed": `VWPSXPUeoaj3Rv439YpH`
};
export default ___CSS_LOADER_EXPORT___;
